<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
    >
    </Main>
  </div>
</template>
<script>
import Main from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, },
  props: {
    orderTechDocCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false }, // 作为标识，判断用户操作是否执行API还是删除缓存中的数据，应为该组件在表格展开插槽中使用也在表格中使用
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderTechDocCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .orderTechDocSpecListApi({
          orderTechDocCode: this.orderTechDocCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
  },
}
</script>
